<div class="buttons-wrapper flex justify-between w-full">
  @if (showSecondaryButton) {
    <app-nicky-button variant="secondary" [id]="secondaryButtonId" (click)="onSecondaryClick()">
      {{ secondaryButtonText | translate }}
    </app-nicky-button>
  } @else {
    <div></div>
  }
  @if (showPrimaryButton) {
    <app-nicky-button
      [variant]="primaryButtonVariant"
      [id]="primaryButtonId"
      [disabled]="primaryButtonDisabled"
      (click)="onPrimaryClick()"
    >
      {{ primaryButtonText | translate }}
    </app-nicky-button>
  }
</div>
